import { Injectable } from '@angular/core';
import { UserApi } from '@shared/services/users';
import { StoreBase } from '@stores/abstract';

@Injectable({ providedIn: 'root' })
export class UserStore extends StoreBase<UserApi> {
  override storeName = 'UserStore';
}
